<template>
    <div class="gallery-feed-view-toggle">
        <label id="feedCheckboxLabel" for="feedViewCheckbox" class="gallery-feed-view-toggle__label"><span class="sr-only" >{{labels.layoutMode}}</span></label>
        <div aria-labelledby="feedCheckboxLabel" id="feedViewCheckbox" class="gallery-feed-view-toggle__button" role="radiogroup">
            <span class="switch">
                <span aria-hidden="false" class="feed" @keydown="onSwitchKeyDown" role="radio" tabindex="0" :aria-checked="layoutMode == 'feed' ? 'true': 'false'" :class="{'active' : layoutMode == 'feed'}" :title="labels.layoutModeFeedTitle" :aria-label="labels.layoutModeFeed" @click="updateLayoutMode('feed')"></span>
                <span aria-hidden="false" class="grid" @keydown="onSwitchKeyDown" role="radio" tabindex="0" :aria-checked="layoutMode == 'grid' ? 'true': 'false'" :class="{'active' : layoutMode == 'grid'}" :title="labels.layoutModeGridTitle" :aria-label="labels.layoutModeGrid" @click="updateLayoutMode('grid')"></span>
            </span>
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';

    export default {
        name: 'GalleryLayoutModeToggle',
        data() {
            return {
            }
        },

        computed: {
            ...mapState('gallery', [
                'layoutMode',
                'galleryVersion',
            ]),

            ...mapState('translations', [
                'labels',
            ])
        },

        methods: {
            ...mapMutations('gallery', [
                'updateLayoutMode',
                'toggleLayoutMode',
            ]),

            onSwitchKeyDown(event) {
                if (event.code === 'Space' || event.key === 'Enter') {
                    event.preventDefault();
                    this.toggleLayoutMode();
                }
            }
        }
    }
</script>